import React from 'react';
export const ScrollContext = React.createContext({
  scrollTop: 0,
});
